import React from 'react';
import { clsx } from 'clsx';

interface StepIndicatorProps {
  steps: number;
  currentStep: number;
  labels?: string[];
}

export const StepIndicator: React.FC<StepIndicatorProps> = ({
  steps,
  currentStep,
  labels,
}) => {
  return (
    <div className="w-full">
      {/* Progress bar */}
      <div className="relative flex justify-between mb-4">
        {/* Connecting line - positioned behind circles */}
        <div className="absolute top-5 left-0 right-0 flex items-center px-8">
          {Array.from({ length: steps - 1 }).map((_, index) => (
            <div
              key={`line-${index}`}
              className={clsx(
                'flex-1 h-1 transition-all',
                {
                  'bg-balloon': index < currentStep,
                  'bg-gray-200': index >= currentStep,
                }
              )}
            />
          ))}
        </div>
        
        {/* Step circles and labels */}
        {Array.from({ length: steps }).map((_, index) => (
          <div key={index} className="flex flex-col items-center z-10">
            <div
              className={clsx(
                'w-10 h-10 rounded-full flex items-center justify-center font-semibold transition-all',
                index <= currentStep
                  ? 'bg-balloon text-white'
                  : 'bg-gray-200 text-gray-500',
                index === currentStep && 'ring-4 ring-balloon/20'
              )}
            >
              {index < currentStep ? '✓' : index + 1}
            </div>
            {labels && labels[index] && (
              <span
                className={clsx(
                  'text-xs mt-2 text-center hidden md:block w-16',
                  {
                    'text-balloon font-medium': index <= currentStep,
                    'text-gray-400': index > currentStep,
                  }
                )}
              >
                {labels[index]}
              </span>
            )}
          </div>
        ))}
      </div>

    </div>
  );
};
